

import React, { useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  useMediaQuery,
 Container
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import Footer from "./Footer";

const theme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          color: "white",
          backgroundColor: "transparent",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "white",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "white",
          },
          "&.Mui-focused": {
            backgroundColor: "black !important",
          },
        },
        input: {
          color: "white",
          "&::placeholder": {
            color: "rgba(255, 255, 255, 0.7)",
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "white",
          "&.Mui-focused": {
            color: "white",
          },
        },
      },
    },
  },
});

const ContactTab = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Ensures the page loads at the top instantly
  }, []);

 const isMobile = useMediaQuery("(max-width: 900px)");
 
  

  return (
    <ThemeProvider theme={theme}>
      {/* Entire Page Wrapper */}
      <Box sx={{  backgroundColor:"#B0E0E6", minHeight: "100vh", paddingBottom: "50px" }}>
        
        {/* Background Image Section */}
        <Box
          sx={{
            position: "relative",
            backgroundImage: `url(${process.env.PUBLIC_URL}/image/contactimage.jpg)`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            minHeight: "60vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
            px: { xs: "20px", sm: "30px", md: "100px" },
          }}
        >
          {/* Main Heading */}
          <Typography
            variant="h3"
            sx={{
              color: "white",
              fontWeight: "bold",
              textShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
              fontFamily: "Proxima Nova",
              fontSize: { xs: "40px", sm: "36px", md: "48px", lg: "64px" },
              maxWidth: "90%",
            }}
          >
            "Your vision, our expertise—limitless possibilities."
          </Typography>

          {/* Subheading */}
          <Typography
            variant="h6"
            sx={{
              color: "white",
              fontWeight: "normal",
              textShadow: "1px 1px 3px rgba(0, 0, 0, 0.5)",
              fontSize: { xs: "16px", sm: "18px", md: "22px", lg: "24px" },
              maxWidth: "80%",
              marginTop: "10px",
            }}
          >
            Thank you for your interest in Tech Informatic Solution. Let us know what you need, 
            and we will have you connected to the right person.
          </Typography>
        </Box>



        <Box
      sx={{
        //backgroundImage: `url("/image/bgfull.jpg")`,
      //  backgroundColor:"#B0E0E6",
        py: 6,
        px: 2,
        textAlign: "center",
        minHeight: "30vh",
      }}
    >
      <Container maxWidth="md" sx={{ mb: 4 }}>
      <Typography
  variant="h2"
  sx={{
    fontWeight: "bold",
    color: "black",
    fontSize: {
      xs: "1.8rem",  // Small screens (mobile)
      sm: "2.2rem",  // Tablets
      md: "2.5rem",  // Medium screens
      lg: "3rem",    // Large screens
      xl: "3.5rem",  // Extra large screens
    },
    textAlign: "center", // Centers text for better responsiveness
    mt: 2, // Adds margin-top for spacing
  }}
  mb={8}
>   Clarity to Grow. Certainty to Succeed
        </Typography>
        <Typography variant="body1" sx={{ lineHeight: 1.6, fontSize: isMobile ? "1rem" : "1.2rem", mt: 2, color: "black" }}>
        Partner with a global strategy consulting firm that delivers unrivaled insights to drive extraordinary outcomes for your business. Let’s connect to discuss your goals and how we can help you gain confidence and clarity on every decision. </Typography>
      </Container>
</Box>







        {/* Centered Heading */}
        
        <Typography
          variant="h4"
          align="center"
          fontWeight="bold"
          sx={{
            fontSize: { xs: "32px", sm: "42px", md: "54px" },
            color: "black",
            marginTop: "-20px",
          }}
        >
          Get in touch with us
        </Typography>

        {/* Contact Form and Corporate Info */}
        <Box
  sx={{
    backgroundColor: "#161623",
    padding: "40px",
    borderRadius: "10px",
    width: "100%",  // Ensure the box occupies 100% width of its parent container
    maxWidth: "1400px",  // Wider container
    margin: "auto",
    marginTop: "20px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
    px: { xs: "15px", sm: "30px", md: "40px" },  // Padding adjustments for different screen sizes
  }}
>
  <Grid container spacing={3}>
    {/* Enquiry Form */}
    <Grid item xs={12} md={6}>
      <Typography variant="h6" color="white">ENQUIRY</Typography>
      
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: isMobile?"92%":"100%",
        }}
      >
        <TextField fullWidth label="Your Name" margin="normal" variant="outlined" />
        <TextField fullWidth label="Your Email" margin="normal" variant="outlined" />
        <TextField fullWidth label="Subject" margin="normal" variant="outlined" />
        <TextField fullWidth label="Message" multiline rows={4} margin="normal" variant="outlined" />
        
        <Button
          variant="contained"
          sx={{
            backgroundColor: "red",
            color: "white",
            borderRadius: "30px",
            padding: "10px 20px",
            marginTop: "15px",
            textTransform: "none",
            fontWeight: "bold",
            "&:hover": { backgroundColor: "#d00000" },
          }}
        >
          Submit
        </Button>
      </Box>
    </Grid>

    {/* Corporate Office Info */}
    <Grid item xs={12} md={6} sx={{ paddingLeft: { xs: 0, md: "20px",transform: isMobile?"translateX(0px)":"translateX(150px)" },  marginTop: { xs: "20px", md: "40px" } }}>
      
      <Typography variant="body2" sx={{ marginTop: "5px", color: "white", display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography><strong>Email :</strong>&nbsp; Info@techinformatic.com</Typography>
        <Typography><strong>Phone :</strong>&nbsp; +91 84830 62624</Typography>
        <Typography><strong>Website :</strong>&nbsp; www.techinformatic.com</Typography>
      </Typography>
    </Grid>
  </Grid>
</Box>

</Box>

   



      <Box sx={{ px: { xs: 2, md: 6 }, py: 8,       backgroundColor: "#161623" }} mb={-2}>
  {/* Heading */}
  <Typography variant="h3" align="center" color="white" fontWeight="bold" mb={4}>
    Let's Discuss Your Project!
  </Typography>
  <Typography
    variant="body1"
    align="center"
    mb={12}
    sx={{ maxWidth: "800px", mx: "auto" }}
    fontSize={18}
    color="white"
 
  >
    Share your project idea and we’ll provide a free consultation on how we
    will turn it into an amazing digital product.
  </Typography>

  {/* Map & Address */}
 <Grid container spacing={4}>
  {/* Map - 3/4th */}
  <Grid item xs={12} md={9}>
    <Box
      sx={{
        width: "100%",
        height: { xs: 300, sm: 400, md: 572 }, // Adjust height for mobile view
        borderRadius: 2,
        boxShadow: 3,
        overflow: "hidden",
      }}
    >
      <iframe
        src="https://www.google.com/maps/d/u/0/embed?mid=1W6r5XzNzdW_U4LiyBgcKWC6N7BoACXU&ehbc=2E312F&noprof=1"
        width="100%"
        height="100%"
        style={{ border: 0, borderRadius: "10px" }}
        allowFullScreen=""
        loading="lazy"
        title="All Tech Informatic Locations"
      />
    </Box>
  </Grid>



    {/* Addresses - 1/4th */}
    <Grid item xs={12} md={3}>
      <Box sx={{ display: "flex", color:"white", flexDirection: "column", gap: 4 }}>
        <Box>
          <Typography fontWeight="bold" mb={2}>Chennai Office</Typography>
          <Typography>No 8 San Jose Appartment</Typography>
          <Typography>10,11,12 Customs colony, Thoraipakkam</Typography>
          <Typography>Chennai, 600097</Typography>
          <Typography> Contact : +91 84830 62624</Typography>
        </Box>

        <Box>
          <Typography fontWeight="bold" mb={2}>Kerala Office</Typography>
          <Typography>CASA, 4th Ward, Near Coffee Routes</Typography>
          <Typography>Attapallam PO, Kumily, Idukki Dist</Typography>
          <Typography>Kerala 685509</Typography>
          <Typography> Contact : +91 84830 62624</Typography>
        </Box>

        <Box>
          <Typography fontWeight="bold" mb={2}>USA Office</Typography>
          <Typography>9606 Whispering Meadow Dr</Typography>
          <Typography>Charlotte, NC 28078</Typography>
          <Typography> Contact : +1 989 933 6262</Typography>
        </Box>

        <Box>
          <Typography fontWeight="bold" mb={2}>Canada Office</Typography>
          <Typography>8212 44 St SE, Calgary, AB T2B 1J1</Typography>
          <Typography> Contact  :  + 1  678 919 9100</Typography>
        </Box>

        <Box mt={2}>
         
        </Box>
      </Box>
    </Grid>
  </Grid>
</Box>







      <Footer/>
    </ThemeProvider>
  );
};

export default ContactTab;
